import Image from 'next/image'
import React from 'react'
import WhoWeAreImage from '@/assets/about-us/who-we-are-user.webp'
import { Col } from 'react-bootstrap'
import Pill from '@/components/base/Pill'
import { HiOutlineLightningBolt } from 'react-icons/hi'

const WhoWeAre = () => {
	return (
		<div className='about-us-who-we-are'>
			<Col xs={12} md={12} lg={6} className='first'>
				<Image src={WhoWeAreImage} alt='..' />
			</Col>

			<Col xs={12} md={12} lg={6} className='second'>
				<Pill icon={<HiOutlineLightningBolt />} text={'Who We Are'} type='secondary' />
				<p className='who-we-are-content'>
					<br />
					{`As a vertically integrated player, 
					we provide a spectrum of `}
					<u>{`Value Added Services`}</u>
					{`. Our mission is to unite all stakeholders onto a single network
					through partnerships and technology.
					We strive to minimize environmental impact by optimizing resource utilization
					and promote a `}
					<u>{`Sustainable Future `}</u>
					{`in the `}
					<u>{`Metal Supply Chain.`}</u>
					<br /> <br />
					{`Our services span from `}
					<u>{`Sourcing`}</u>
					{` premium finished and recycled goods, providing `}
					<u>{`Fabricated`}</u>
					{` products, `}
					<u>{`Financing`}</u>
					{` solutions and end-to-end `}
					{`Logistics`}.{' '}
				</p>
			</Col>
		</div>
	)
}

export default WhoWeAre
